import summaryPlot from "../../../../content/posts/data-release-notes/gm24385_2021.10/q20summary.jsx";
import * as React from 'react';
export default {
  summaryPlot,
  React
};